<template>
  <v-container style="padding-top:0px;">
    <v-container>
      
      <v-layout justify-center>
        <v-progress-circular v-if="dataList.length == 0 && mosaicedImageURL == null"
          :size="70"
          :width="7"
          color="blue"
          indeterminate
        ></v-progress-circular>
      </v-layout>

      <v-row>
        <v-col 
          v-for="(data, index) in dataList"
          :key="index"
          class="d-flex child-flex face-card"
          cols="4"
        >
          <v-card flat tile 
            v-bind:class="['d-flex', isSelected(index) ? 'active-card' : '']">
            <v-img
              :src="`${data.image}`"
              :lazy-src="`${data.image}`"
              :aspect-ratio="1"
              :contain= "true"
              v-bind:class="['lighten-2', isSelected(index) ? 'active-img' : 'grey']"
              @click="onImageClicked(index)"
              >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-icon color="#448AFF" class="selectable-icon" v-if="isSelected(index)" @click="onImageClicked(index)">mdi-checkbox-marked-circle</v-icon>
            <v-icon color="#BDBDBD" class="selectable-icon" v-else @click="onImageClicked(index)">mdi-checkbox-blank-circle-outline</v-icon>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="button-row" v-if="dataList.length > 0">
        <v-col align="center" class="button-col"  >
          <v-btn :loading="loadingA" :disabled="loadingA" color="#3F51B5" class="white--text" @click="mosaicToCheck">
            MOSAIC TO
            <v-icon color="#448AFF" right dark>mdi-checkbox-marked-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col align="center" class="button-col">
          <v-btn :loading="loadingB" :disabled="loadingB" color="#3F51B5" class="white--text" @click="mosaicToUnCheck">
            MOSAIC TO
          <v-icon color="#BDBDBD" right dark>mdi-checkbox-blank-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="mosaicedImageURL != null" justify="center">
        <div style="justify-content: stretch;">
        <img
          :src="mosaicedImageURL"
          style="width:auto; height: auto; max-width:100%; max-height:auto; min-heigth: auto;"/>
        </div>
      </v-row>

      <v-layout justify-center>
        <v-btn v-if="iOSFlg == false && dataList.length < 0 && mosaicedImageURL != null"
          :loading="loadingC" :disabled="loadingC" color="#3F51B5" class="white--text" @click="downloadImage">
          <v-icon>mdi-download</v-icon>
          Download
        </v-btn>
        
        <p v-if="dataList.length > 0 && mosaicedImageURL != null" color="#1a237e" text-color="white" style="font-size: 12px;">
          <v-icon>mdi-download</v-icon>
          DOWNLOAD BY LONG-PRESS THE IMAGE
        </p>
        <p v-if="dataList.length == 0 && mosaicedImageURL != null" color="#1a237e" text-color="white" style="font-size: 12px;">
          <v-icon>mdi-account-question-outline</v-icon>
          OOPS!! THE FACE DOSE NOT EXIST.
        </p>
        
        <v-progress-circular v-if="dataList.length > 0 && mosaicedImageURL === null"
          :size="70"
          :width="7"
          color="blue"
          indeterminate
        ></v-progress-circular>
      </v-layout>

      <v-layout justify-center style="margin-top: 24px;">
        <v-btn v-if="dataList.length > 0 && mosaicedImageURL != null"
          :loading="loading" :disabled="loading" color="#3F51B5" class="ma-2 white--text " @click="selectImage">
          <v-icon color="white" left dark>mdi-face</v-icon>
          <v-icon color="white" left dark>mdi-face-woman</v-icon>
          SELECT A PHOTO !!
          <v-icon color="white" right dark>mdi-baby-face-outline </v-icon>
          <v-icon color="white" right dark>mdi-github-face </v-icon>
        </v-btn>
      </v-layout>

    </v-container>
  </v-container> 
</template>

<script>
import { API, graphqlOperation, Storage } from 'aws-amplify';
import { listMosaicProdTables } from "../graphql/queries";
import { onCreateMosaicProdTable } from "../graphql/subscriptions";
import { processApplyMosaic } from "../graphql/mutations";
import { eventBus } from "../main";

const dataExpireSeconds = (30 * 60);
export default {
  name: 'List',
  data: () => ({
    group: null, 
    dataList: [], 
    selectedIndexList: [], 
    orgKey: null, 
    mosaicedImageURL: null, 
    myGuid: null, 
    loader: null, 
    loading: false,
    loadingA: false,
    loadingB: false,
    loadingC: false, 
    iOSFlg: false
  }), 
  watch: {
    $route(to, from) {
      this.dataList = [];
      this.selectedIndexList = [];
      this.mosaicedImageURL = null;
      this.myGuid = null;
      this.getList();
    }, 

    loader () {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    },
  },
  mounted: async function() {
    this.iOSFlg = this.isiOS();
    this.getList();
  }, 
  methods:{
    async getList() {
      if(!this.$route.query.group){
          return;
      }

      this.group = this.$route.query.group;
      console.log("group : " + this.group);
      
      let apiResult = await API.graphql(graphqlOperation(listMosaicProdTables, { group : this.group }));
      let listAll = apiResult.data.listMosaicProdTables.items;
      this.getListFromAPIResult(listAll);
      
      API.graphql(
          graphqlOperation(onCreateMosaicProdTable, { group : this.group } )
      ).subscribe({
          next: (eventData) => {
            let data = eventData.value.data.onCreateMosaicProdTable;
            this.getData(data);
          }
      });
    }, 
    
    async getListFromAPIResult(dataList) {
      for(let data of dataList) {
        this.getData(data);
      }
    }, 
    
    async getData(data) {
      console.log("path : " + data.path);
      if(data.type == 0){
        this.orgKey = data.path;
      }else{
        let tmp = { type: data.type, path : data.path, image : "", roi : data.roi, points : data.points };
        Storage.get(data.path.replace('public/', ''), { expires: dataExpireSeconds }).then(result => {
          tmp.image = result;
          if(data.type == 5 && this.myGuid == null){
            this.mosaicedImageURL = result;
          }else if(data.type == 6 && this.myGuid != null && data.path.indexOf(this.myGuid) > 0){
            this.mosaicedImageURL = result;
          }
          console.log(data.type + " : image : " + result);
        }).catch(err => console.log(err));
        if(data.type == 1 || data.type == 2 || data.type == 3 || data.type == 4){
          let list = [...this.dataList, tmp];
          this.dataList = list;
        }
      }
    }, 
    
    isiOS() {
    	var ua = [
    		"iPod",
    		"iPad",
    		"iPhone"
    	];
    	
    	for (var i = 0; i < ua.length; i++) {
    		if (navigator.userAgent.indexOf(ua[i]) > 0) {
    			return true;
    		}
    	}
    	return false;
    },
    
    isSelected(index){
      return (this.selectedIndexList.includes(index));
    }, 

    onImageClicked(selectedIndex){
      if(this.isSelected(selectedIndex)){
        const deleteIndex = this.selectedIndexList.findIndex((index) => index === selectedIndex);
        this.selectedIndexList.splice(deleteIndex, 1);
      }else{
        this.selectedIndexList.push(selectedIndex);
      }
      window.navigator.vibrate(10);
    }, 
    
    mosaicToCheck() {
      this.loader = 'loadingA';

      let roiList = [];
      let pointsList = [];
      for(let index of this.selectedIndexList) {
        let data = this.dataList[index];
        console.log(index + " : " + "type=" + data.type + ", path=" + data.path + ", roi=" + data.roi);
        roiList.push(data.roi);
        pointsList.push(data.points);
      }
      
      this.mosaicApplyByAPI(roiList, pointsList);
    }, 
    
    mosaicToUnCheck() {
      this.loader = 'loadingB';

      let roiList = [];
      let pointsList = [];
      for(let index = 0; index < this.dataList.length; index++) {
        if(this.selectedIndexList.indexOf(index) < 0) {
          let data = this.dataList[index];
          console.log(index + " : " + "type=" + data.type + ", s3key=" + data.s3key + ", roi=" + data.roi + ", points=" + data.points);
          roiList.push(data.roi);
          pointsList.push(data.points);
        }
      }
      
      this.mosaicApplyByAPI(roiList, pointsList);
    }, 
    
    async mosaicApplyByAPI(roiList, pointsList) {
      this.mosaicedImageURL = null;
      this.myGuid = this.getGUIDString(new Date());

      let requestData = { guid: this.myGuid, orgKey: this.orgKey, roiList: roiList, pointsList: pointsList }; 
      console.log(requestData);
      
      let apiResult = await API.graphql(graphqlOperation(processApplyMosaic, 
        { input : requestData })
      ).catch(error => {
        console.error(error);
      });

      console.log("api done!!");
    }, 
    
    getGUIDString(date){
      let random = date.getTime() + Math.floor(100000 * Math.random());
      random = Math.random() * random;
      random = Math.floor(random).toString(16);
      return "" + 
        ("00" + date.getUTCFullYear()).slice(-2) + 
        ("00" + (date.getMonth() + 1)).slice(-2) + 
        ("00" + date.getUTCDate()).slice(-2) + 
        ("00" + date.getUTCHours()).slice(-2) + 
        ("00" + date.getUTCMinutes()).slice(-2) + 
        ("00" + date.getUTCSeconds()).slice(-2) + 
        "-" + random;
    }, 

    downloadImage() {
      this.loader = 'loadingC';
      
      var fileNameIndex = this.mosaicedImageURL.lastIndexOf("/") + 1;
      var filename = this.mosaicedImageURL.substr(fileNameIndex, prmIndex);
      var prmIndex = filename.lastIndexOf("?");
      filename = filename.substr(0, prmIndex);
      
      console.log("name : " + filename);

      axios({
        method: 'get',
        url: this.mosaicedImageURL,
        responseType: 'blob'
      })
      .then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch(error => console.log(error))
    }, 

    selectImage() {
      eventBus.$emit("onSelectImage");
    }, 

  }
}
</script>

<style>
.face-card{
  margin: 0px;
  padding: 4px;
}
.active-card{
  padding: 2px;
}
.active-img {
  border: solid #4285F4;
}
.selectable-icon {
  position: absolute;
  left: 8px;
  top: 8px;
  font-size: 25px;
  color: #4285F4;
}
.button-row {
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 0px;
  border: 0px solid #F00;
}
.button-col {
  margin-right: 0px;
  margin-left: 0px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 0px;
}
</style> 
